 <!-- <div mat-dialog-actions> -->
  <!-- <button mat-button (click)="onClose()">Close</button> -->
<!-- </div>  -->
<!-- <h1>Dialog Content</h1> -->


<div class = "dialog-header-container">
  <h2 mat-dialog-title class="mar-b-5 pd-t-5px">Preview Minutes Template</h2>
  <div> 
    <button mat-icon-button mat-dialog-close>
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mat-divider"></mat-divider>
<div>
<div mat-dialog-content [innerHTML]="htmlContent"></div>
</div>
<!-- {{htmlContent}} -->
